var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProjectManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1C3.01472 1 1 3.01472 1 5.5C1 7.98528 3.01472 10 5.5 10C5.6615 10 5.82102 9.99149 5.97812 9.9749C5.8388 10.2925 5.73916 10.6405 5.67068 10.9974C5.614 10.9991 5.5571 11 5.5 11C2.46243 11 0 8.53757 0 5.5C0 2.46243 2.46243 0 5.5 0C8.53757 0 11 2.46243 11 5.5C11 6.54498 10.7086 7.5219 10.2026 8.35391C10.0892 8.35466 9.97548 8.35466 9.86121 8.35466C9.56812 8.35466 9.27142 8.35467 8.96829 8.36741C9.61272 7.58882 10 6.58964 10 5.5C10 3.01472 7.98528 1 5.5 1ZM5 5V2.5H6V5H8.5V6H6V8.5H5V6H2.5V5H5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1007 5.7978C15.0343 5.66512 14.9017 5.57666 14.769 5.57666C14.6584 5.57666 14.5478 5.643 14.4594 5.77569C13.7738 6.96987 12.5575 7.69964 11.1643 7.69964H9.39517C7.05104 7.69964 5.1492 9.60148 5.1492 11.9456C5.1492 12.3437 5.19343 12.7196 5.304 13.0956C3.66754 14.5109 3.04833 16.1695 3.04833 16.2137C2.95988 16.4791 3.09256 16.7887 3.38005 16.8771C3.68965 16.9877 3.95502 16.7887 4.04348 16.5454C4.0656 16.5233 4.50789 15.2849 5.72418 14.1128C6.56453 15.506 8.13465 16.3464 9.83746 16.1695C13.3094 15.9262 15.7641 12.8081 15.7641 9.00439C15.7641 7.89867 15.5209 6.74872 15.1007 5.7978ZM9.72689 15.1301C7.82505 15.3291 6.8299 13.9138 6.58664 13.4273C7.62602 12.6975 9.06345 12.1225 10.9874 12.1225C11.2749 12.1225 11.5182 11.9014 11.5182 11.5918C11.5182 11.3043 11.2749 11.061 10.9874 11.061C8.95288 11.061 7.42699 11.636 6.25492 12.3879C6.23281 12.2331 6.2107 12.1004 6.2107 11.9456C6.2107 10.1986 7.62602 8.76114 9.39517 8.76114H11.1643C12.447 8.76114 13.619 8.27462 14.5257 7.43427C14.6363 7.9429 14.7026 8.47365 14.7026 9.00439C14.7026 12.3437 12.6239 14.9089 9.72689 15.1301Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectManagement);
export default __webpack_public_path__ + "static/media/project-management.048233a45699c4cea8070ddcec41625f.svg";
export { ForwardRef as ReactComponent };